import range from 'lodash/range'

const startYear = 1970
const endYearExclusive = 2022

export const GRAD_YEARS = range(endYearExclusive, startYear)
